import { SettingsContext } from './SettingsContext';

export const SettingsConsumer = SettingsContext.Consumer; 